import React, { Component } from 'react';
import Tibbit_base from '@appblocks/frontend/client/Components/TPP/Tibbit_base';

export default class Tibbit_module_wide extends Tibbit_base {
    constructor(props: any) {
        super(props);
        this.width = 101.879;
        this.height = 99.141;
    }

    render() {
        return (
            <g id="module_wide" {...this.props} className="tibbit">
                <rect className="draggable" x="0" y="0" width="101.882" height="99.141" />
                <rect id="color" className={`moduleColor_${this.props.category}`} x="0" y="0" width="101.882" height="99.141" />

                <path className="recess" d="M9.731,95.75H0.001V3.392h9.729v4.209h-5.27v2.82h5.27v3.94h-5.27v2.819h5.27v3.939h-5.27v2.82h5.27v3.941&#10;&#9;&#9;h-5.27v2.819h5.27v3.94h-5.27v2.818h5.27V41.4h-5.27v2.82h5.27v3.941h-5.27v2.819h5.27v3.94h-5.27v2.82h5.27v3.94h-5.27V64.5h5.27&#10;&#9;&#9;v3.941h-5.27v2.82h5.27v3.939h-5.27v2.82h5.27v3.938h-5.27v2.82h5.27v3.94h-5.27v2.819h5.27V95.75z M92.152,3.394v4.211h5.261v2.82&#10;&#9;&#9;h-5.261v3.938h5.261v2.819h-5.261v3.939h5.261v2.82h-5.261v3.939h5.261v2.819h-5.261v3.94h5.261v2.824h-5.261v3.94h5.261v2.819&#10;&#9;&#9;h-5.261v3.939h5.261v2.82h-5.261v3.94h5.261v2.818h-5.261v3.939h5.261v2.819h-5.261v3.94h5.261v2.82h-5.261v3.938h5.261v2.819&#10;&#9;&#9;h-5.261v3.939h5.261v2.82h-5.261v3.939h5.261v2.819h-5.261v4.21h9.729V3.394H92.152z" />

                <polygon transform="rotate (-90 49.569 49.569)" className="labelColor" points="3.398,87.87 95.75,87.879 95.76,22.649 87.311,13.99 3.39,13.999 &#9;" />

                <g id="label">
                    <text transform="matrix(1 0 0 1 20.8613 17)" className="label" id="num">{this.props.num}</text>
                    <text transform="matrix(1 0 0 1 21.2163 28.2717)" className="desc" id="desc">
                        {this.renderDescriptions()}
                    </text>
                </g>
                <g id="lines">
                    {this.renderLines()}
                </g>

                <rect className="tibbitStroke" x="0" y="0" width="101.882" height="99.141" />
                {/* <image xlinkHref={"https://docs.tibbo.com/phm/label-" + this.props.num.replace('#', '') + ".png"}
                    x={3} y={3} width={this.width - 5} height={this.height - 7} /> */}
                {this.renderWiring()}
            </g>
        );
    }
}
